import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StockTakeBulkDownloadQueryVariables = Types.Exact<{
  facilityId: Types.Scalars['ID'];
  locationId: Types.Scalars['ID'];
}>;


export type StockTakeBulkDownloadQuery = { readonly __typename?: 'Query', readonly stockTakeBulkDownload: { readonly __typename?: 'BulkDownloadResult', readonly totalCount: number, readonly csv: string } };

export type ValidateStockTakeBulkUploadQueryVariables = Types.Exact<{
  input: Types.StockTakeBulkValidateInput;
}>;


export type ValidateStockTakeBulkUploadQuery = { readonly __typename?: 'Query', readonly validateStockTakeBulkUpload?: { readonly __typename?: 'StockTakeBulkValidationResult', readonly totalSent: number, readonly totalToUpdate: number, readonly totalUnchanged: number, readonly totalErrors: number, readonly totalModifiedSinceExport: number, readonly rows: ReadonlyArray<{ readonly __typename?: 'StockTakeBulkRowValidation', readonly rowIndex: number, readonly lotId?: string | null, readonly skuName?: string | null, readonly expiryDate?: string | null, readonly systemQuantity?: number | null, readonly actualCount?: number | null, readonly discrepancy?: number | null, readonly willUpdate: boolean, readonly modifiedSinceExport: boolean, readonly hasError: boolean, readonly errorMessage?: string | null }> } | null };

export type StockTakeBulkUploadMutationVariables = Types.Exact<{
  input: Types.StockTakeBulkUploadInput;
}>;


export type StockTakeBulkUploadMutation = { readonly __typename?: 'Mutation', readonly stockTakeBulkUpload: { readonly __typename?: 'StockTakeBulkUploadResult', readonly stockTakeId?: string | null, readonly totalSent: number, readonly totalUpdated: number, readonly totalErrors: number, readonly errors: ReadonlyArray<{ readonly __typename?: 'BulkUploadError', readonly id: string, readonly errorMessage?: string | null }> } };


export const StockTakeBulkDownloadDocument = gql`
    query stockTakeBulkDownload($facilityId: ID!, $locationId: ID!) {
  stockTakeBulkDownload(facilityId: $facilityId, locationId: $locationId) {
    totalCount
    csv
  }
}
    `;

/**
 * __useStockTakeBulkDownloadQuery__
 *
 * To run a query within a React component, call `useStockTakeBulkDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockTakeBulkDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockTakeBulkDownloadQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useStockTakeBulkDownloadQuery(baseOptions: Apollo.QueryHookOptions<StockTakeBulkDownloadQuery, StockTakeBulkDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockTakeBulkDownloadQuery, StockTakeBulkDownloadQueryVariables>(StockTakeBulkDownloadDocument, options);
      }
export function useStockTakeBulkDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockTakeBulkDownloadQuery, StockTakeBulkDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockTakeBulkDownloadQuery, StockTakeBulkDownloadQueryVariables>(StockTakeBulkDownloadDocument, options);
        }
export type StockTakeBulkDownloadQueryHookResult = ReturnType<typeof useStockTakeBulkDownloadQuery>;
export type StockTakeBulkDownloadLazyQueryHookResult = ReturnType<typeof useStockTakeBulkDownloadLazyQuery>;
export type StockTakeBulkDownloadQueryResult = Apollo.QueryResult<StockTakeBulkDownloadQuery, StockTakeBulkDownloadQueryVariables>;
export const ValidateStockTakeBulkUploadDocument = gql`
    query validateStockTakeBulkUpload($input: StockTakeBulkValidateInput!) {
  validateStockTakeBulkUpload(input: $input) {
    totalSent
    totalToUpdate
    totalUnchanged
    totalErrors
    totalModifiedSinceExport
    rows {
      rowIndex
      lotId
      skuName
      expiryDate
      systemQuantity
      actualCount
      discrepancy
      willUpdate
      modifiedSinceExport
      hasError
      errorMessage
    }
  }
}
    `;

/**
 * __useValidateStockTakeBulkUploadQuery__
 *
 * To run a query within a React component, call `useValidateStockTakeBulkUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateStockTakeBulkUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateStockTakeBulkUploadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateStockTakeBulkUploadQuery(baseOptions: Apollo.QueryHookOptions<ValidateStockTakeBulkUploadQuery, ValidateStockTakeBulkUploadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateStockTakeBulkUploadQuery, ValidateStockTakeBulkUploadQueryVariables>(ValidateStockTakeBulkUploadDocument, options);
      }
export function useValidateStockTakeBulkUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateStockTakeBulkUploadQuery, ValidateStockTakeBulkUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateStockTakeBulkUploadQuery, ValidateStockTakeBulkUploadQueryVariables>(ValidateStockTakeBulkUploadDocument, options);
        }
export type ValidateStockTakeBulkUploadQueryHookResult = ReturnType<typeof useValidateStockTakeBulkUploadQuery>;
export type ValidateStockTakeBulkUploadLazyQueryHookResult = ReturnType<typeof useValidateStockTakeBulkUploadLazyQuery>;
export type ValidateStockTakeBulkUploadQueryResult = Apollo.QueryResult<ValidateStockTakeBulkUploadQuery, ValidateStockTakeBulkUploadQueryVariables>;
export const StockTakeBulkUploadDocument = gql`
    mutation stockTakeBulkUpload($input: StockTakeBulkUploadInput!) {
  stockTakeBulkUpload(input: $input) {
    stockTakeId
    totalSent
    totalUpdated
    totalErrors
    errors {
      id
      errorMessage
    }
  }
}
    `;
export type StockTakeBulkUploadMutationFn = Apollo.MutationFunction<StockTakeBulkUploadMutation, StockTakeBulkUploadMutationVariables>;

/**
 * __useStockTakeBulkUploadMutation__
 *
 * To run a mutation, you first call `useStockTakeBulkUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStockTakeBulkUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stockTakeBulkUploadMutation, { data, loading, error }] = useStockTakeBulkUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStockTakeBulkUploadMutation(baseOptions?: Apollo.MutationHookOptions<StockTakeBulkUploadMutation, StockTakeBulkUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StockTakeBulkUploadMutation, StockTakeBulkUploadMutationVariables>(StockTakeBulkUploadDocument, options);
      }
export type StockTakeBulkUploadMutationHookResult = ReturnType<typeof useStockTakeBulkUploadMutation>;
export type StockTakeBulkUploadMutationResult = Apollo.MutationResult<StockTakeBulkUploadMutation>;
export type StockTakeBulkUploadMutationOptions = Apollo.BaseMutationOptions<StockTakeBulkUploadMutation, StockTakeBulkUploadMutationVariables>;